import { AdminState } from '../../model/admin/adminState';
import {
  CHANGE_ACCOUNT_ROLE,
  CLEAR_ACCOUNTS,
  FETCH_HCP_ACCOUNTS_SUCCESS,
  FETCH_INVITES_SUCCESS,
  FETCH_PATIENT_ACCOUNTS_SUCCESS,
  TOGGLE_ACCOUNT_2FA_ENABLED_SUCCESS,
} from '../constants';
import { initialState } from '../system/SystemState';
import { AdminActionTypes } from '../types/adminActionTypes';

export default function adminReducer(
  state = initialState.admin,
  action: AdminActionTypes
): AdminState {
  switch (action.type) {
    case FETCH_HCP_ACCOUNTS_SUCCESS:
      return {
        ...state,
        hcpAccounts: action.payload.map((a: any) => ({
          ...a,
          role: Number(a.role),
        })),
      };
    case FETCH_PATIENT_ACCOUNTS_SUCCESS:
      return {
        ...state,
        patientAccounts: action.payload.map((a: any) => ({
          ...a,
          role: Number(a.role),
        })),
      };
    case CHANGE_ACCOUNT_ROLE:
      return {
        ...state,
        hcpAccounts: state.hcpAccounts.map((el) => {
          if (el.accountGuid === action.payload.accountId) {
            return {
              ...el,
              role: Number(action.payload.role),
            };
          }
          return el;
        }),
      };
    case CLEAR_ACCOUNTS:
      return {
        ...state,
        hcpAccounts: [],
      };
    case FETCH_INVITES_SUCCESS:
      return {
        ...state,
        invitationCodes: action.payload,
      };
    case TOGGLE_ACCOUNT_2FA_ENABLED_SUCCESS:
      return {
        ...state,
        hcpAccounts: state.hcpAccounts.map((el) => {
          if (el.accountGuid === action.payload.accountGuid) {
            return {
              ...el,
              isTwoFactorAuthenticationEnabled: action.payload.isEnabled,
            };
          }
          return el;
        }),
      };
    default:
      return state;
  }
}
